import { render, staticRenderFns } from "./character.vue?vue&type=template&id=513b700b&scoped=true&"
import script from "./character.vue?vue&type=script&lang=js&"
export * from "./character.vue?vue&type=script&lang=js&"
import style0 from "./character.vue?vue&type=style&index=0&id=513b700b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b700b",
  null
  
)

component.options.__file = "character.vue"
export default component.exports